export function hideIfEmpty(value, arr) {
  return value ? arr : [];
}
